import React, { Component } from 'react';
import Time from 'react-time-format';
import ReactMarkdown from 'react-markdown';
import { Mentions, Button as AntdButton, Tooltip, Image, DatePicker, message } from 'antd';
import { Cookies } from 'react-cookie';
import { EditOutlined, DeleteOutlined, CheckOutlined, CloseOutlined, EyeOutlined, PaperClipOutlined, StarFilled, FieldTimeOutlined, BellOutlined } from '@ant-design/icons';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import dayjs from 'dayjs';
import { isSysMessage, parseSysDiff } from './MessageRow';

const normalizeBr = (text) => (text || '').replace(/<br\s*\/?>/gi, '\n');

const { Option } = Mentions;
const cookies = new Cookies();
var token = cookies.get('token');

const splitAdjacentMarkdownLinks = (text) => {
	if (!text) return text;
	return text.replace(/(\]\([^)]+\))(\[)/g, '$1\n\n$2');
};

const CJK_RE = /[一-鿿]/;

const initials = (name) => {
	if (!name) return '?';
	if (CJK_RE.test(name)) return name.slice(-2);
	return name.split(/\s+/).map(w => w[0]).slice(0, 2).join('').toUpperCase();
};

const AV_COLORS = ['#3a93d6', '#7e57c2', '#26a69a', '#ef6c40', '#5c8a3a', '#c2477e'];
const avatarColor = (name) => {
	if (!name) return '#54687a';
	let h = 0; for (const c of name) h = (h * 31 + c.charCodeAt(0)) >>> 0;
	return AV_COLORS[h % AV_COLORS.length];
};

const PreviewableImage = (props) => {
	const [visible, setVisible] = React.useState(false);
	return (
		<span className="msg-img-wrapper">
			<img {...props} style={{ maxWidth: '100%' }} />
			<span className="msg-img-preview-btn" onClick={() => setVisible(true)}>
				<EyeOutlined /> 预览
			</span>
			<Image
				style={{ display: 'none' }}
				src={props.src}
				preview={{
					visible,
					onVisibleChange: (vis) => setVisible(vis),
				}}
			/>
		</span>
	);
};

const AttachChipRow = ({ documents }) => {
	if (!documents || documents.length === 0) return null;
	return (
		<div className="attach-chip-row">
			{documents.map((doc) => (
				<a key={doc.uid} className="attach-chip" href={doc.url} target="_blank" rel="noopener noreferrer" title={doc.name}>
					<PaperClipOutlined />
					<span className="nm">{doc.name}</span>
				</a>
			))}
		</div>
	);
};

const Diff = ({ groups }) => (
	<div className="diff">
		{groups.map((g, i) => (
			<div className="grp" key={i}>
				<div className="label">修改 <span className="tag">{g.field}</span></div>
				<div className="chg">
					{g.from ? <span className="from">{g.from}</span> : <span className="empty">（空）</span>}
					<span className="arrow">→</span>
					{g.to ? <span className="to">{g.to}</span> : <span className="empty">（空）</span>}
				</div>
			</div>
		))}
	</div>
);

class ReplyRow extends Component {

	state = {
		relation_id: this.props.relation_id,
		index: this.props.index,
		messageID: this.props.messageID,
		showEditMessageForm: false,
		showDestroyMessageButtons: false,
		message: this.props.message,
		hasError: '',
		notices: this.props.notices,
		deadline: this.props.deadline || null,
		fileList: this.props.documents,
	}

	changeEditMessageFormStatus = () => {
		this.setState({ showEditMessageForm: !this.state.showEditMessageForm });
	}

	changeDestroyMessageButtonsStatus = () => {
		this.setState({ showDestroyMessageButtons: !this.state.showDestroyMessageButtons });
	}

	changeMessage = (event) => {
		this.setState({ message: event.target.value });
	}

	updateThisMessage = () => {
		if (this.state.message === '') {
			this.setState({ hasError: 'has-error' });
		} else {
			this.setState({ hasError: '' });
			this.changeEditMessageFormStatus();
			this.props.updateMessage(this.state.messageID, this.state.index, this.state.message, '', this.state.notices, this.state.deadline);
		}
	}

	updateThisRelation = () => {
		this.props.updateRelation(this.state.relation_id, 1);
	}

	destroyThisMessage = () => {
		this.changeDestroyMessageButtonsStatus();
		this.props.destroyMessage(this.state.messageID, this.state.index);
	}

	hasMentionUser = (notices) => /@\S+/.test((notices || '').trim());

	onChangeMentions = (e) => {
		const hasMention = this.hasMentionUser(e);
		this.setState((prevState) => ({
			notices: e,
			deadline: hasMention ? prevState.deadline : null,
		}));
	}

	onChangeDeadline = (date, dateString) => {
		this.setState({ deadline: dateString || null });
	}

	getDeadlineAlert = (deadline) => {
		if (!deadline) return null;
		const dueDate = dayjs(deadline);
		if (!dueDate.isValid()) return null;
		const daysLeft = dueDate.startOf('day').diff(dayjs().startOf('day'), 'day');
		if (daysLeft < 0) return { className: 'alert-expire', label: '已过期' };
		if (daysLeft <= 2) return { className: 'alert-soon', label: `剩${daysLeft}天到期` };
		return null;
	}

	render() {
		const { user, message: msgText, created_at, type, relation_description, notices, users, deadline } = this.props;
		const sys = isSysMessage(msgText);
		const sysGroups = sys ? parseSysDiff(msgText) : [];

		const supportsHandling = (type == 'home' || type == 'invoice' || type == 'order' || type == 'backorder');
		const hasHandlingContext = !!notices || type == 'home';
		const isHandled = supportsHandling && hasHandlingContext && (relation_description === 1 || relation_description === '1' || (relation_description && relation_description !== ''));
		const canMarkHandled = supportsHandling && hasHandlingContext && !relation_description;

		const deadlineAlert = this.getDeadlineAlert(deadline);
		const formattedDeadline = (deadline && dayjs(deadline).isValid()) ? dayjs(deadline).format('YYYY-MM-DD') : null;
		const editShouldShowDeadline = this.hasMentionUser(this.state.notices);

		const editing = this.state.showEditMessageForm;
		const confirmingDelete = this.state.showDestroyMessageButtons;

		const renderActions = () => (
			<div className="msg-actions">
				{confirmingDelete ? (
					<>
						<button className="ok-del" title="确认删除" onClick={this.destroyThisMessage.bind(this)}><CheckOutlined /></button>
						<button className="cancel-del" onClick={this.changeDestroyMessageButtonsStatus.bind(this)}><CloseOutlined /></button>
					</>
				) : (
					<>
						{!sys && canMarkHandled ? (
							<Tooltip title="标记为已处理"><button className="check" onClick={this.updateThisRelation.bind(this)}><CheckOutlined /></button></Tooltip>
						) : null}
						{!sys ? (
							<button className="ed" onClick={this.changeEditMessageFormStatus.bind(this)}><EditOutlined /></button>
						) : null}
						<button className="del" onClick={this.changeDestroyMessageButtonsStatus.bind(this)}><DeleteOutlined /></button>
					</>
				)}
			</div>
		);

		const renderChips = () => (
			<>
				{isHandled ? <span className="status-chip done"><CheckOutlined style={{ fontSize: 10 }} /> 已处理</span> : null}
			</>
		);

		const renderMetaSub = () => {
			const showNotice = notices && supportsHandling;
			if (!showNotice && !formattedDeadline) return null;
			return (
				<div className="meta-sub">
					{showNotice ? <span className="notice"><BellOutlined /> {notices}</span> : null}
					{formattedDeadline ? (
						<span className="deadline">
							<FieldTimeOutlined /> 截止 {formattedDeadline}
							{!isHandled && deadlineAlert ? <span className={deadlineAlert.className} style={{ marginLeft: 6 }}>· {deadlineAlert.label}</span> : null}
						</span>
					) : null}
				</div>
			);
		};

		const renderEditForm = () => (
			<div className={`inline-edit ${this.state.hasError === 'has-error' ? 'has-error' : ''}`}>
				<textarea
					placeholder="留言"
					onChange={this.changeMessage.bind(this)}
					value={this.state.message}
				/>
				{supportsHandling ? (
					<Mentions
						onChange={this.onChangeMentions}
						placeholder='输入 @ 选择要通知的人'
						value={this.state.notices}
					>
						{users.map((v) => <Option key={v.name} value={v.name}>{v.name}</Option>)}
					</Mentions>
				) : null}
				<div className="inline-edit-row" style={{ padding: '8px 10px', background: '#f1f4f6' }}>
					{supportsHandling && editShouldShowDeadline ? (
						<DatePicker
							placeholder="截止日期(可选)"
							format="YYYY-MM-DD"
							allowClear
							onChange={this.onChangeDeadline}
							value={this.state.deadline ? dayjs(this.state.deadline, 'YYYY-MM-DD') : null}
						/>
					) : <span className="spacer" />}
					<AntdButton size="small" type="primary" icon={<CheckOutlined />} onClick={this.updateThisMessage.bind(this)} />
					<AntdButton size="small" icon={<CloseOutlined />} onClick={this.changeEditMessageFormStatus.bind(this)} />
				</div>
			</div>
		);

		if (sys) {
			return (
				<div className={`m sys`}>
					<div className="avatar" style={{ background: avatarColor(user) }}>{initials(user)}</div>
					<div className="body">
						<div className="mhead sys-line">
							<span className="who">{user}</span>
							<span className="when">修改了订单 · <Time value={created_at} format="YYYY-MM-DD HH:mm" /></span>
							<span className="spacer" />
							{renderChips()}
							{renderActions()}
						</div>
						<div className="bubble">
							{editing ? renderEditForm() : (
								sysGroups.length > 0
									? <Diff groups={sysGroups} />
									: <div className="sys-text">{normalizeBr(msgText)}</div>
							)}
						</div>
					</div>
				</div>
			);
		}

		return (
			<div className={`m human ${isHandled ? 'done' : ''}`}>
				<span className="node" />
				<div className="avatar" style={{ background: avatarColor(user) }}>{initials(user)}</div>
				<div className="body">
					<div className="mhead">
						<span className="who">{user}</span>
						<span className="when"><Time value={created_at} format="YYYY-MM-DD HH:mm" /></span>
						{renderChips()}
						<span className="spacer" />
						{renderActions()}
					</div>
					<div className="bubble">
						{editing ? renderEditForm() : (
							<>
								<AttachChipRow documents={this.state.fileList} />
								{msgText ? (
									<div className="content" style={isHandled ? { opacity: .7 } : null}>
										<ReactMarkdown
											linkTarget="_blank"
											children={splitAdjacentMarkdownLinks(msgText)}
											remarkPlugins={[remarkGfm]}
											rehypePlugins={[rehypeRaw]}
											components={{ img: ({ node, ...props }) => <PreviewableImage {...props} /> }}
										/>
									</div>
								) : null}
								{renderMetaSub()}
							</>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default ReplyRow;
